import { render, staticRenderFns } from "./AyudaNotificaciones.vue?vue&type=template&id=2fe3a83b"
import script from "./AyudaNotificaciones.vue?vue&type=script&lang=js"
export * from "./AyudaNotificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports